import { IActionMessage } from '../../../../types/conversations'
import Metadata from '../Metadata/Metadata'

import styles from './action-message.module.scss'

interface IActionMessageProps {
    message: IActionMessage
}

function ActionMessage(props: IActionMessageProps) {
    const { message } = props

    return (
        <div className={styles.actionMessage}>
            {message.name}
            <Metadata
                date={message.timestamp}
                className={styles.actionMessage__metadata}
            />
        </div>
    )
}

export default ActionMessage
